<template>
  <v-layout row>
    <v-flex
      d-flex
      md12
    >
      <v-card>
        <v-form>
          <v-container>
            <v-layout row>
              <v-flex md3>
                <v-text-field
                  v-model="from"
                />
              </v-flex>
              <v-flex md3>
                <v-text-field
                  v-model="to"
                />
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex
                md3
              >
                <v-select
                  v-model="cond.userId"
                  :items="userSelect"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
              <v-flex
                md3
              >
                <v-select
                  v-model="cond.categoryId"
                  :items="categorySelect"
                  item-text="name"
                  item-value="id"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import * as moment from 'moment'

export default {
  props: {
    cond: {
      type: Object,
      default: () => ({
        from: -1,
        to: -1,
        categoryId: -1,
        userId: -1
      })
    },
    categories: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    from: {
      set (value) {
        this.cond.from = this.parse(value)
      },
      get () {
        return this.format(this.cond.from)
      }
    },
    to: {
      set (value) {
        this.cond.to = this.parse(value)
      },
      get () {
        return this.format(this.cond.to)
      }
    },
    userSelect () {
      const select = [{ id: -1, name: '' }]
      select.push(...this.users)
      return select
    },
    categorySelect () {
      const select = [{ id: -1, name: '' }]
      select.push(...this.categories)
      return select
    }
  },
  methods: {
    parse (value) {
      const at = moment(value, 'YYYY-MM-DD HH:mm:ss').utc()

      if (at.isValid()) {
        return at.unix()
      } else {
        return -1
      }
    },
    format (value) {
      if (value === -1) {
        return ''
      } else {
        return moment.unix(value).utcOffset('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
      }
    }
  }
}
</script>
